import { Add, Delete, Info } from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';
import {
    Autocomplete,
    Box,
    Breadcrumbs,
    Button,
    CircularProgress,
    Dialog,
    DialogContent,
    Divider,
    Grid,
    IconButton,
    Stack,
    styled,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Tooltip,
    tooltipClasses,
    Typography,
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../../../App.css';
import '../NumberInput.css';

import { useTheme } from '@emotion/react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toast } from 'sonner';
import { REQUIRED_RED } from '../../../App';
import CommonDialog from '../../../common/CommonDialog';
import DiscountComponent from '../../../components/DiscountComponent/DiscountComponent';
import {
    createSupplierInvoiceApi,
    deletePartFromSupplierInvoiceApi,
    getSupplierInvoiceDetail,
    getSupplierListApi,
    updateSupplierInvoiceApi,
} from '../../../redux/Supplier/action';
import { useGetShopConfig } from '../../../services/core/settings';
import { INVENTORY_TYPES, PART_TYPES, PAYMENT_STATUS, PAYMENT_TERMS, SUPPLIER_INVOICE_STATUS, USER_TIMEZONE } from '../../../utility/Constant';
import BrandSvg from '../../../utility/Svg/BrandSvg';
import PartCategorySvg from '../../../utility/Svg/PartCategorySvg';
import SaveAsDraftSvg from '../../../utility/Svg/SaveAsDraftSvg';
import { filterUndefined, handlePreventKeyDownDecimal, toISOStringUTC } from '../../../utility/helpers/commonFunction';
import { NumericEngine, Raw } from '../../../utility/helpers/numericEngine';
import useDebounce from '../../../utility/useDebounce';
import InputWithIcon from '../../Common/InputWithIcon';
import SuccessMessageModal from '../../Common/SuccessMessage';
import AddInventoryModal from '../../Inventory/AddInventory';
import AddInventoryForSupplierInvoice from '../../Inventory/AddInventoryForSupplierInvoice';
import PartUsedInvoiceModal from './PartUsedInvoiceModal';
// import "../Invoice.css";

const SupplierNewInvoice = () => {
    const debounceTimerRef = useRef(null);
    const {
        handleSubmit,
        control,
        formState: { errors },
        setValue,
        setError,
        clearErrors,
        getValues,
        setFocus,
    } = useForm({
        defaultValues: {
            paymentStatus: {
                key: 'open',
                value: 'Open',
            }, // Set the default value here
            paymentTerms: {
                key: 'none',
                value: 'none',
            },
        },
    });

    const HtmlTooltip = styled(({ className, ...props }) => (
        <Tooltip
            {...props}
            classes={{ popper: className }}
            slotProps={{
                popper: {
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, -12],
                            },
                        },
                    ],
                },
            }}
        />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#DFDFDF',
            boxShadow: '0px 4px 24px 0px rgba(0, 0, 0, 0.08)',
            color: 'rgba(0, 0, 0, 0.87)',
            width: 250,
            fontSize: 14,
            fontWeight: 400,
            letterSpacing: '-0.42px',
            padding: '12px',
            lineHeight: '120%',
            borderRadius: '8px',
        },
        [`& .${tooltipClasses.arrow}`]: {
            color: '#DFDFDF', // Same as tooltip background color
        },
    }));
    const { id, supplierId } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const params = new URLSearchParams(window.location.search);

    const [batchParams, setBatchParams] = useState(params.get('batch'));

    const [messageType, setMessagetype] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const [saveIndex, setSaveIndex] = useState(0);
    const [partsList, setPartsList] = useState([]);
    console.log('🚀 ~ SupplierNewInvoice ~ partsList:', partsList);
    const [selectedInventory, setSelectedInventory] = useState([]);
    const [selectedInventoryId, setSelectedInventoryId] = useState(null);

    const [batchNumber, setBatchNumber] = useState(null);
    const [partInvoiceModal, setPartInvoiceModal] = useState(false);

    const [IsSaveDraft, setIsSaveDraft] = useState(false);
    const [inventoryLoader, isSetInventoryLoader] = useState(false);

    const [supplierInvoiceDate, setSupplierInvoiceDate] = useState(null);
    const [pastOrderDate, setPastOrderDate] = useState(null);
    const [pastReceivedDate, setPastReceivedDate] = useState(null);
    const [render, setRender] = useState(false);

    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
    const [isDelete, setIsDelete] = useState(false);

    const [totals, setTotals] = useState({
        subTotal: 0,
        discount: 0,
        taxPercentage: 13,
        tax: 0,
        estimatedTotal: 0,
        discountPercentage: 0,
    });
    console.log('🚀 ~ SupplierNewInvoice ~ totals:', totals);

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [openSuccessModal, setOpenSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');

    const [discountError, setDiscountError] = useState(false);
    const [openPartModel, setOpenPartModel] = useState(false);

    const [supplierInput, setSupplierInput] = useState('');
    const debouncedSupplierInput = useDebounce(supplierInput, 500);

    const supplierList = useSelector((state) => state?.supplier?.supplierData?.data);
    const supplierInvoiceDetail = useSelector((state) => state.supplier?.supplierInvoiceDetail?.data);

    const isFinalizedInvoice = id && supplierInvoiceDetail && !supplierInvoiceDetail?.isDraft;

    useEffect(() => {
        if (supplierId) {
            setValue('supplierId', supplierId);
        }
    }, [supplierId]);

    useEffect(() => {
        if (debouncedSupplierInput) {
            fetchSupplierList(debouncedSupplierInput);
        } else {
            fetchSupplierList(supplierInput);
        }
    }, [debouncedSupplierInput]);

    useEffect(() => {
        if (id) {
            fetchSupplierInvoiceDetail();
        }
    }, []);

    useEffect(() => {
        if (id && supplierInvoiceDetail?._id) {
            const discount = Number(supplierInvoiceDetail?.discountAmount) > 0 ? Number(supplierInvoiceDetail.discountAmount) : 0;

            const totalAmount = Number(supplierInvoiceDetail?.totalAmount) || 0;
            const taxAmount = Number(supplierInvoiceDetail?.taxAmount) || 0;

            const subTotal = totalAmount > taxAmount ? NumericEngine.subtract(totalAmount, taxAmount) : 0;

            const tax = Number(supplierInvoiceDetail?.taxAmount) > 0 ? Number(supplierInvoiceDetail.taxAmount) : 0;

            // Calculate discount percentage if membership discount is available
            const discountPercentage = Number(supplierInvoiceDetail?.discountPercentage) > 0 ? Number(supplierInvoiceDetail.discountPercentage) : 0;

            const taxPercentage = Number(supplierInvoiceDetail?.taxPercentage) > 0 ? Number(supplierInvoiceDetail.taxPercentage) : 0;

            const estimatedTotal = Number(supplierInvoiceDetail?.totalAmount) || 0;

            setTotals({
                discount,
                tax,
                estimatedTotal,
                taxPercentage,
                subTotal,
                discountPercentage, // Set discount percentage if applicable
            });

            // setPartsList(supplierInvoiceDetail?.parts);
            const partsArray = [];
            if (supplierInvoiceDetail?.parts?.length > 0) {
                supplierInvoiceDetail?.parts.map((item, index) => {
                    partsArray.push({
                        isUsedInCustomerInvoice: item?.isUsedInCustomerInvoice || false,
                        customerInvoices: item?.customerInvoices || [],
                        inventoryId: item?.inventory,
                        batchNumber: item?.batchNumber,
                        partsType: item?.part?.partsType,
                        partId: item?.part?._id,
                        partNumber: item?.partNumber,
                        tyreDimension: item?.tyreDimension,
                        tyreModel: item?.item?.tyreModel,
                        partName: item?.part?.partName,
                        description: item?.description,
                        partsCategory: item?.partsCategory,
                        partsBrand: item?.partsBrand,
                        partsCategoryName: item?.partsCategory?.name,
                        partsBrandName: item?.partsBrand?.name,
                        tyreModelName: item?.tyreModel?.name,
                        qty: item?.qty,
                        cost: item?.cost,
                        totalAmount: NumericEngine.multiply(item?.qty || 1, item?.cost || 0),
                        partsProvider: item?.partsProvider,
                        pricingMethod: item?.pricingMethod,
                        retailPrice: item?.retailPrice,
                        marginPercentage: item?.marginPercentage,
                        markupPercentage: item?.markupPercentage,
                        feeName: item?.fee?.name || undefined,
                        feeAmount: item?.feeAmount || undefined,
                        // retailPrice: item?.retailPrice,
                        // profitPerUnit: 0,
                        // totalRetailPrice: 700,
                        // totalProfit: 0,
                    });
                });
            }
            setPartsList(partsArray);
            setValue('supplierId', supplierInvoiceDetail?.supplier?._id);
            setValue('invoiceNumber', supplierInvoiceDetail?.invoiceNumber);

            // Set paymentTerms
            const selectedPaymentTerm = PAYMENT_TERMS.find((term) => term.key === supplierInvoiceDetail?.paymentTerms);
            setValue('paymentTerms', selectedPaymentTerm);

            // Set paymentStatus
            const selectedPaymentStatus = PAYMENT_STATUS.find((status) => status.key === supplierInvoiceDetail?.paymentStatus);
            setValue('paymentStatus', selectedPaymentStatus);

            if (supplierInvoiceDetail?.amountPaid) {
                setValue('amountPaid', supplierInvoiceDetail?.amountPaid);
            }
            //Set dates
            if (supplierInvoiceDetail?.supplierInvoiceDate) {
                setSupplierInvoiceDate(
                    supplierInvoiceDetail?.supplierInvoiceDate
                        ? dayjs(dayjs(supplierInvoiceDetail.supplierInvoiceDate).tz(USER_TIMEZONE).format('YYYY-MM-DD'))
                        : null
                );

                setValue(
                    'supplierInvoiceDate',
                    supplierInvoiceDetail?.supplierInvoiceDate
                        ? dayjs(dayjs(supplierInvoiceDetail.supplierInvoiceDate).tz(USER_TIMEZONE).format('YYYY-MM-DD'))
                        : null
                );
            }

            if (supplierInvoiceDetail?.partsOrderedDate) {
                setPastOrderDate(
                    supplierInvoiceDetail?.partsOrderedDate ? dayjs(dayjs(supplierInvoiceDetail.partsOrderedDate).tz(USER_TIMEZONE).format('YYYY-MM-DD')) : null
                );

                setValue(
                    'partsOrderedDate',
                    supplierInvoiceDetail?.partsOrderedDate ? dayjs(dayjs(supplierInvoiceDetail.partsOrderedDate).tz(USER_TIMEZONE).format('YYYY-MM-DD')) : null
                );
            }

            if (supplierInvoiceDetail?.partsReceivedDate) {
                setPastReceivedDate(
                    supplierInvoiceDetail?.partsReceivedDate
                        ? dayjs(dayjs(supplierInvoiceDetail.partsReceivedDate).tz(USER_TIMEZONE).format('YYYY-MM-DD'))
                        : null
                );

                setValue(
                    'partsReceivedDate',
                    supplierInvoiceDetail?.partsReceivedDate
                        ? dayjs(dayjs(supplierInvoiceDetail.partsReceivedDate).tz(USER_TIMEZONE).format('YYYY-MM-DD'))
                        : null
                );
            }
            if (batchParams) {
                setSelectedInventoryId(supplierInvoiceDetail?.parts[0]?.inventory);
                setBatchNumber(batchParams);
                setOpenPartModel(true);
                setBatchParams(null);
            }
        }
    }, [supplierInvoiceDetail]);

    const fetchSupplierInvoiceDetail = async () => {
        setShowLoader(true);
        await dispatch(getSupplierInvoiceDetail(id));
        setShowLoader(false);
    };

    useEffect(() => {
        if (partsList.length > 0) {
            // Calculate subtotal by summing up each part's totalAmount or deriving it from qty and cost
            const subTotal = partsList.reduce((acc, part) => {
                const partTotalAmount = part?.totalAmount ? NumericEngine.format(part.totalAmount) : NumericEngine.multiply(part?.qty || 0, part?.cost || 0);

                return NumericEngine.add(acc, partTotalAmount);
            }, 0);

            // Ensure discount values are valid numbers

            let discountPercentage = Number(totals?.discountPercentage) || 0;
            let discountValue = NumericEngine.divide(Raw.mul(subTotal, discountPercentage), 100);
            // Reset discount if subtotal is zero
            if (subTotal === 0) {
                discountValue = 0;
                discountPercentage = 0;
            }

            // Calculate tax
            const taxPercentage = Number(totals?.taxPercentage) || 0;

            // Calculate tax based on subtotal after discount
            let tax = taxPercentage > 0 ? NumericEngine.multiply(Raw.div(taxPercentage, 100), NumericEngine.subtract(subTotal, discountValue)) : 0;

            // Calculate estimated total
            let estimatedTotal = NumericEngine.add(NumericEngine.subtract(subTotal, discountValue), tax);

            // Update totals state
            setTotals({
                subTotal: subTotal,
                taxPercentage,
                discount: discountValue,
                tax: tax,
                estimatedTotal,
                discountPercentage,
            });
        }
    }, [partsList]);

    const fetchSupplierList = async (searchTerm) => {
        await dispatch(getSupplierListApi({ search: searchTerm }));
    };

    const onInvalid = (errors) => {
        const firstErrorField = Object.keys(errors)[0];
        if (firstErrorField) {
            const errorElement = document.querySelector(`[name=${firstErrorField}]`);
            if (errorElement) {
                errorElement.scrollIntoView({ behavior: 'smooth' });
                setTimeout(() => {
                    const offset = 100; // Adjust the offset value as needed
                    const elementPosition = errorElement.getBoundingClientRect().top;
                    const offsetPosition = elementPosition - offset;
                    window.scrollBy({ top: offsetPosition, behavior: 'smooth' });
                    setFocus(firstErrorField);
                }, 0);
            }
        }
    };

    const cancelInvoice = () => {};

    const onSubmitInvoice = async (values, autoUpdate = null) => {
        try {
            if (!IsSaveDraft && partsList.length < 0) {
                toast.error('Please add atleast one part');
                return;
            }

            if (values?.paymentStatus?.key === 'partial_payment') {
                if (values.amountPaid > totals.estimatedTotal) {
                    toast.error('Payment amount cannot be higher that pending amount.');
                    setError('amountPaid', {
                        message: 'amountPaid',
                    });
                    return;
                }
            }
            const payload = {
                isDraft: IsSaveDraft,
                supplierId: values?.supplierId,
                invoiceNumber: values.invoiceNumber,
                paymentTerms: values?.paymentTerms?.key || PAYMENT_TERMS[0]?.key,
                paymentStatus: values?.paymentStatus?.key || undefined,
            };
            if (values?.paymentStatus?.key === 'partial_payment') {
                payload.amountPaid = values.amountPaid;
            }
            if (values.partsOrderedDate) {
                // payload.partsOrderedDate = dayjs(pastOrderDate).format('YYYY-MM-DD');
                payload.partsOrderedDate = toISOStringUTC(values.partsOrderedDate);
            }
            if (values.partsReceivedDate) {
                // payload.partsReceivedDate = dayjs(pastReceivedDate).format('YYYY-MM-DD');
                payload.partsReceivedDate = toISOStringUTC(values.pastReceivedDate);
            }
            if (values.supplierInvoiceDate) {
                // payload.supplierInvoiceDate = dayjs(supplierInvoiceDate).format('YYYY-MM-DD');
                payload.supplierInvoiceDate = toISOStringUTC(values.supplierInvoiceDate);
            }

            const parts = [];
            if (partsList.length > 0) {
                partsList.map((item, index) => {
                    const obj = {
                        partName: item?.part?.partName || item?.partName,
                        partsType: item?.partsType,
                        partNumber: item?.partNumber,
                        tyreDimension: item?.tyreDimension,
                        tyreModelName: item?.tyreModel?.name || item?.tyreModelName || undefined,
                        partsBrandName: item?.partsBrand?.name || item?.partsBrandName || undefined,
                        partsCategoryName: item?.partsCategory?.name || item?.partsCategoryName || undefined,
                        partsProvider: item.partsProvider,
                        description: item?.description,
                        qty: item.qty,
                        cost: item.cost,
                        pricingMethod: item.pricingMethod,
                        retailPrice: item.retailPrice,
                        marginPercentage: item.marginPercentage,
                        markupPercentage: item.markupPercentage,

                        feeName: item?.feeName || undefined,
                        feeAmount: Number(item?.feeAmount) > 0 ? Number(item?.feeAmount) : undefined,
                    };
                    if (item?.partsType === PART_TYPES.PARTS) {
                        delete obj.tyreModelName;
                        delete obj.tyreDimension;
                    } else {
                        delete obj.partsCategoryName;
                        delete obj.partNumber;
                    }
                    parts.push(filterUndefined(obj));
                });
            }
            payload.parts = parts;

            payload.discountPercentage = totals?.discountPercentage;
            payload.taxPercentage = Number(totals?.taxPercentage || 0);

            if (isFinalizedInvoice) {
                delete payload.parts;
            }
            console.log('payload supplier invoice ', payload);

            // return;
            setShowLoader(true);
            let resp;

            if (isFinalizedInvoice) {
                resp = await dispatch(updateSupplierInvoiceApi(id, filterUndefined(payload)));
            } else if (id && id !== '') {
                payload._id = id;
                resp = await dispatch(createSupplierInvoiceApi(filterUndefined(payload)));
            } else {
                resp = await dispatch(createSupplierInvoiceApi(filterUndefined(payload)));
            }

            if (resp?._id) {
                if (autoUpdate === true) {
                } else if (payload.isDraft) {
                    navigate(`/suppliers-invoice/draft/${resp?._id}`);
                } else {
                    if (payload.paymentStatus === SUPPLIER_INVOICE_STATUS.OPEN) {
                        navigate(`/suppliers-invoice/open/${resp?._id}`);
                    }
                    if (payload.paymentStatus === SUPPLIER_INVOICE_STATUS.PARTIAL) {
                        navigate(`/suppliers-invoice/partial/${resp?._id}`);
                    }
                    if (payload.paymentStatus === SUPPLIER_INVOICE_STATUS.FULL) {
                        navigate(`/suppliers-invoice/paid/${resp?._id}`);
                    }
                }
            }
        } catch (error) {
            console.log('🚀 ~ onSubmitInvoice ~ error:', error);
        } finally {
            setShowLoader(false);
        }
    };

    // Use TanStack Query for shop config instead of Redux
    const { data: shopConfigData, isLoading: isConfigLoading, error: configError } = useGetShopConfig();

    useEffect(() => {
        if (shopConfigData?.config?.customerInvoiceTaxes?.length > 0) {
            const isDefault = shopConfigData?.config?.customerInvoiceTaxes.find((item) => item?.isDefault);
            setTimeout(() => {
                if (!id) {
                    if (isDefault?.shouldIncludeTax) {
                        setTotals((prevDetails) => ({
                            ...prevDetails,
                            taxPercentage: NumericEngine.format(isDefault?.taxRate),
                        }));
                    }
                }
            }, 300);
        }
    }, [shopConfigData]);

    return (
        <>
            <Box
                padding={'32px 24px'}
                sx={{
                    width: 'fit-content',
                    minWidth: '100%',
                }}
            >
                {' '}
                <SuccessMessageModal message={successMessage} open={openSuccessModal} setOpenSuccessModal={setOpenSuccessModal} alertType={messageType} />
                <form onSubmit={handleSubmit(onSubmitInvoice, onInvalid)}>
                    <Grid container sx={{ padding: '16px 0px' }} gap={'8px'}>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <div role="presentation">
                                <Breadcrumbs aria-label="breadcrumb">
                                    <Link to="/suppliers-invoice/all" style={{ color: '#00000099', textDecoration: 'none' }}>
                                        Supplier / {id ? 'Edit' : 'New'} Supplier Invoice
                                    </Link>
                                </Breadcrumbs>
                            </div>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography variant="h4" sx={{ fontWeight: '500' }}>
                                {id ? 'Edit ' : 'New '}
                                Supplier Invoice
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container padding={'24px'} margin={' 17px 0px 32px 0'} boxShadow={2} bgcolor={'white'} borderRadius={2}>
                        <Grid container item justifyItems={'space-between'}>
                            <Grid container item justifyItems={'space-between'} rowGap={3} padding={'10px 0px'} columnSpacing={2}>
                                {/* SupplierField  */}
                                <Grid item xl={4} lg={4} md={4} sm={6} xs={12}>
                                    <Stack spacing={0}>
                                        <Typography variant="body1" className="label-500">
                                            Supplier <span style={{ color: REQUIRED_RED }}>*</span>
                                        </Typography>
                                        <Controller
                                            name="supplierId"
                                            control={control}
                                            rules={{
                                                required: 'Supplier is required',
                                            }}
                                            render={({ field }) => (
                                                <Autocomplete
                                                    {...field}
                                                    disabled={(id && id !== '') || (supplierId && supplierId !== '')}
                                                    options={supplierList?.length > 0 ? supplierList : []}
                                                    getOptionLabel={(option) => (typeof option === 'string' ? option : option?.name || '')}
                                                    value={
                                                        (supplierList && supplierList?.length > 0 && supplierList.find((item) => item._id === field.value)) ||
                                                        null
                                                    }
                                                    onChange={(event, newValue) => {
                                                        field.onChange(newValue?._id || '');
                                                    }}
                                                    ListboxProps={{
                                                        style: { maxHeight: '280px' },
                                                    }}
                                                    renderOption={(props, option) => (
                                                        <li
                                                            {...props}
                                                            style={{
                                                                height: '44px',
                                                                paddingRight: '0px',
                                                            }}
                                                        >
                                                            {option.name}
                                                        </li>
                                                    )}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            error={!!errors.supplierId}
                                                            helperText={errors.supplierId ? errors.supplierId.message : ''}
                                                            sx={{
                                                                '& .MuiAutocomplete-inputRoot': {
                                                                    paddingRight: '9px!important', // Add paddingRight here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                            )}
                                        />
                                    </Stack>
                                </Grid>
                                {/* invoiceNumberField  */}
                                <Grid item xl={4} lg={4} md={4} sm={6} xs={12}>
                                    <Typography className="edit-invoice-form-title style-15-500-24-px">
                                        Invoice Number <span style={{ color: REQUIRED_RED }}>*</span>
                                    </Typography>

                                    <Controller
                                        name="invoiceNumber"
                                        control={control}
                                        rules={{
                                            required: 'Invoice number is required',
                                        }}
                                        render={({ field }) => (
                                            <TextField
                                                // disabled={id && id !== ""}
                                                {...field}
                                                variant="outlined"
                                                fullWidth
                                                disabled={!supplierInvoiceDetail?.isDraft && id && id !== ''}
                                                error={!!errors.invoiceNumber}
                                                helperText={errors.invoiceNumber ? errors.invoiceNumber.message : ''}
                                                {...field}
                                                onChange={(event) => {
                                                    field.onChange(event.target.value);
                                                }}
                                                InputLabelProps={{ shrink: field.value?.length > 0 }}
                                            />
                                        )}
                                    />
                                </Grid>
                                {/* paymentTermsField  */}
                                <Grid item xl={4} lg={4} md={4} sm={6} xs={12}>
                                    <Typography className="edit-invoice-form-title style-15-500-24-px">Payment Terms</Typography>
                                    <Controller
                                        name="paymentTerms"
                                        control={control}
                                        render={({ field }) => (
                                            <Autocomplete
                                                fullWidth
                                                options={PAYMENT_TERMS}
                                                getOptionLabel={(option) => option.value}
                                                getOptionKey={(option) => option.key} // Optional, for consistency
                                                value={PAYMENT_TERMS.find((item) => item.key === field.value?.key) || null}
                                                onChange={(_, newValue) => field.onChange(newValue)}
                                                ListboxProps={{
                                                    style: { maxHeight: '280px' },
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} error={!!errors.paymentTerms} helperText={errors.paymentTerms?.message || ''} />
                                                )}
                                                renderOption={(props, option) => (
                                                    <li
                                                        key={option.key}
                                                        {...props}
                                                        style={{
                                                            height: '44px',
                                                            paddingRight: '0px',
                                                        }}
                                                    >
                                                        {option.value}
                                                    </li>
                                                )}
                                            />
                                        )}
                                    />
                                </Grid>

                                {/* supplierInvoiceDateField  */}
                                <Grid item xl={4} lg={4} md={4} sm={6} xs={12} className="width-100-pers">
                                    <Typography className="edit-invoice-form-title style-15-500-24-px">
                                        Supplier Invoice Date <span style={{ color: REQUIRED_RED }}>*</span>
                                    </Typography>
                                    <Controller
                                        name="supplierInvoiceDate"
                                        control={control}
                                        rules={{
                                            required: 'Supplier Invoice Date is required',
                                        }}
                                        render={({ field: { onChange, value, ref, onBlur, name }, fieldState: { error } }) => (
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    name={name}
                                                    ref={ref}
                                                    onBlur={onBlur}
                                                    value={supplierInvoiceDate || null}
                                                    onChange={(date) => {
                                                        setSupplierInvoiceDate(dayjs(dayjs(date).format('YYYY-MM-DD')));
                                                        onChange(date);
                                                    }}
                                                    style={{ width: '100%' }}
                                                    slotProps={{
                                                        textField: {
                                                            error: !!error, // Set error state for TextField
                                                            helperText: error ? error.message : undefined, // Set helper text
                                                        },
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            error={!!error.supplierInvoiceDate}
                                                            helperText={error.supplierInvoiceDate ? error.supplierInvoiceDate.message : ''}
                                                            required={true}
                                                        />
                                                    )}
                                                />
                                            </LocalizationProvider>
                                        )}
                                    />
                                </Grid>

                                {/* partsOrderDateField  */}
                                <Grid item xl={4} lg={4} md={4} sm={6} xs={12} className="width-100-pers">
                                    <Typography className="edit-invoice-form-title style-15-500-24-px">Parts Ordered Date</Typography>

                                    <Controller
                                        name="partsOrderedDate"
                                        control={control}
                                        // rules={{
                                        //   required: "Past ordered date is required",
                                        // }}
                                        render={({ field: { onChange, value, ref, onBlur, name }, fieldState: { error } }) => (
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    name={name}
                                                    ref={ref}
                                                    onBlur={onBlur}
                                                    value={pastOrderDate || null}
                                                    onChange={(date) => {
                                                        setPastOrderDate(dayjs(dayjs(date).format('YYYY-MM-DD')));
                                                        onChange(date);
                                                    }}
                                                    style={{ width: '100%' }}
                                                    slotProps={{
                                                        textField: {
                                                            error: !!error, // Set error state for TextField
                                                            helperText: error ? error.message : undefined, // Set helper text
                                                        },
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            error={!!error.partsOrderedDate}
                                                            helperText={error.partsOrderedDate ? error.partsOrderedDate.message : ''}
                                                            required={true}
                                                        />
                                                    )}
                                                />
                                            </LocalizationProvider>
                                        )}
                                    />
                                </Grid>

                                {/* partsReceivedDateField  */}
                                <Grid item xl={4} lg={4} md={4} sm={6} xs={12} className="width-100-pers">
                                    <Typography className="edit-invoice-form-title style-15-500-24-px">Parts Received Date</Typography>

                                    <Controller
                                        name="partsReceivedDate"
                                        control={control}
                                        // rules={{
                                        //   required: "Supplier Invoice Date is required",
                                        // }}
                                        render={({ field: { onChange, value, ref, onBlur, name }, fieldState: { error } }) => (
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    name={name}
                                                    ref={ref}
                                                    onBlur={onBlur}
                                                    value={pastReceivedDate || null}
                                                    onChange={(date) => {
                                                        setPastReceivedDate(dayjs(dayjs(date).format('YYYY-MM-DD')));
                                                        onChange(date);
                                                    }}
                                                    style={{ width: '100%' }}
                                                    slotProps={{
                                                        textField: {
                                                            error: !!error, // Set error state for TextField
                                                            helperText: error ? error.message : undefined, // Set helper text
                                                        },
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            error={!!error.partsReceivedDate}
                                                            helperText={error.partsReceivedDate ? error.partsReceivedDate.message : ''}
                                                            required={true}
                                                        />
                                                    )}
                                                />
                                            </LocalizationProvider>
                                        )}
                                    />
                                </Grid>
                            </Grid>

                            <Divider
                                style={{
                                    width: '100%',
                                    borderBottomStyle: 'dotted',
                                    borderBottomWidth: '4px',
                                    marginTop: '24px',
                                    marginBottom: '24px',
                                }}
                            />
                            {/* partsTable  */}
                            <Grid container item>
                                <Grid item xl={12} md={12} sm={12} xs={12} boxShadow={0}>
                                    <div className="tableScroll">
                                        <Table
                                            aria-label="caption table"
                                            padding="16px"
                                            style={{ boxShadow: 2 }} // Set a minimum width for the table
                                        >
                                            <TableHead
                                                style={{
                                                    backgroundColor: '#f4f6f8',
                                                    fontWeight: 500,
                                                }}
                                            >
                                                <TableRow>
                                                    <TableCell align="left" width={80}>
                                                        No.
                                                    </TableCell>
                                                    <TableCell style={{ width: '300px' }}>Description</TableCell>
                                                    <TableCell style={{ width: '300px' }}>Brand/Category</TableCell>
                                                    <TableCell align="left">Quantity</TableCell>
                                                    <TableCell align="left">Cost</TableCell>
                                                    <TableCell align="left">Amount</TableCell>
                                                    <TableCell style={{ padding: '0', width: '60px' }} />
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {Array.isArray(partsList) &&
                                                    partsList.map((part, index) => {
                                                        return (
                                                            <TableRow
                                                                key={index}
                                                                style={{
                                                                    // opacity: part.isUpdate ? "0.5" : "",
                                                                    cursor: 'default',
                                                                }}
                                                            >
                                                                <TableCell component="th" align="left" scope="row" padding="16px">
                                                                    {index + 1}
                                                                </TableCell>
                                                                <TableCell
                                                                    align="left"
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'flex-start',
                                                                        gap: '8px',
                                                                    }}
                                                                >
                                                                    <div>
                                                                        <Typography
                                                                            sx={{
                                                                                fontSize: '14px',
                                                                                fontWeight: 400,
                                                                                letterSpacing: '0.17px',
                                                                                lineHeight: '143%',
                                                                                textDecoration: 'underline',
                                                                                cursor: part.isUsedInCustomerInvoice ? 'default' : 'pointer',
                                                                            }}
                                                                            onClick={() => {
                                                                                if (!part.isUsedInCustomerInvoice) {
                                                                                    setSaveIndex(index);
                                                                                    if (isFinalizedInvoice) {
                                                                                        setSelectedInventoryId(partsList[index]?.inventoryId);
                                                                                    } else {
                                                                                        setSelectedInventoryId(partsList[index]);
                                                                                    }

                                                                                    setBatchNumber(part.batchNumber);
                                                                                    setOpenPartModel(true);
                                                                                }
                                                                            }}
                                                                        >
                                                                            {part?.partName}
                                                                        </Typography>
                                                                        {(part.partNumber || part.tyreDimension) && (
                                                                            <Typography
                                                                                sx={{
                                                                                    fontSize: '14px',
                                                                                    fontWeight: 400,
                                                                                    letterSpacing: '0.17px',
                                                                                    lineHeight: '143%',
                                                                                }}
                                                                            >
                                                                                {part.partNumber || part.tyreDimension}
                                                                            </Typography>
                                                                        )}
                                                                    </div>
                                                                    {part.isUsedInCustomerInvoice && (
                                                                        <HtmlTooltip
                                                                            title={
                                                                                <React.Fragment>
                                                                                    <span>This part is connected with customer invoice and not editable.</span>
                                                                                    <br />
                                                                                    <Button
                                                                                        variant="contained"
                                                                                        color="primary"
                                                                                        style={{
                                                                                            textTransform: 'uppercase',
                                                                                            fontSize: 12,
                                                                                            marginTop: 11,
                                                                                            height: '28px',
                                                                                            display: 'flex',
                                                                                            alignItems: 'center',
                                                                                            padding: '0 8px',
                                                                                        }}
                                                                                        onClick={() => {
                                                                                            setBatchNumber(part?.batchNumber || '');
                                                                                            setSelectedInventoryId(part?.inventoryId || '');
                                                                                            setPartInvoiceModal(true);
                                                                                        }}
                                                                                    >
                                                                                        View Customer invoice
                                                                                    </Button>
                                                                                </React.Fragment>
                                                                            }
                                                                            placement="top"
                                                                            arrow
                                                                        >
                                                                            <IconButton style={{ padding: '0' }}>
                                                                                <Info
                                                                                    style={{
                                                                                        fill: '#0000008F',
                                                                                    }}
                                                                                />
                                                                            </IconButton>
                                                                        </HtmlTooltip>
                                                                    )}
                                                                </TableCell>
                                                                <TableCell align="left" min={548} style={{ padding: '10px 12px' }}>
                                                                    {part?.partsBrandName && (
                                                                        <Typography
                                                                            padding={0}
                                                                            sx={{
                                                                                color: 'rgba(0, 0, 0, 0.87)',
                                                                                letterSpacing: '0.17px',
                                                                                fontSize: '14px',
                                                                                fontWeight: 400,
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                gap: '6px',
                                                                                marginBottom: '4px',
                                                                            }}
                                                                            lineHeight={'normal'}
                                                                        >
                                                                            <BrandSvg />
                                                                            {part?.partsBrandName}
                                                                        </Typography>
                                                                    )}
                                                                    {part?.partsCategoryName && (
                                                                        <Typography
                                                                            padding={0}
                                                                            sx={{
                                                                                color: 'rgba(0, 0, 0, 0.87)',
                                                                                letterSpacing: '0.17px',
                                                                                fontSize: '14px',
                                                                                fontWeight: 400,
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                gap: '6px',
                                                                                marginBottom: '4px',
                                                                            }}
                                                                            lineHeight={'normal'}
                                                                        >
                                                                            <PartCategorySvg />
                                                                            {part?.partsCategoryName}
                                                                        </Typography>
                                                                    )}
                                                                    {part?.tyreModelName && (
                                                                        <Typography
                                                                            padding={0}
                                                                            sx={{
                                                                                color: 'rgba(0, 0, 0, 0.87)',
                                                                                letterSpacing: '0.17px',
                                                                                fontSize: '14px',
                                                                                fontWeight: 400,
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                gap: '6px',
                                                                                marginBottom: '4px',
                                                                            }}
                                                                            lineHeight={'normal'}
                                                                        >
                                                                            <PartCategorySvg />
                                                                            {part?.tyreModelName}
                                                                        </Typography>
                                                                    )}
                                                                </TableCell>
                                                                <TableCell align="left" width={108} style={{ padding: '6px 12px' }}>
                                                                    <InputWithIcon
                                                                        value={part?.qty}
                                                                        hideEndAdornment={part.isUsedInCustomerInvoice}
                                                                        borderRadius={'4px'}
                                                                        skipOnChange={true}
                                                                        onChange={(numericValue) => {
                                                                            if (part.isUsedInCustomerInvoice) {
                                                                                return;
                                                                            }
                                                                            if (numericValue === '' || /^\d*(\.\d{0,1})?$/.test(numericValue)) {
                                                                                let clonePartList = JSON.parse(JSON.stringify(partsList));
                                                                                const qty = Number(numericValue) || 0;
                                                                                const retailPrice = part?.cost || 0;
                                                                                const totalAmount = NumericEngine.multiply(qty, retailPrice);

                                                                                clonePartList[index].qty = numericValue;
                                                                                clonePartList[index].totalAmount = totalAmount;
                                                                                setPartsList(clonePartList);

                                                                                if (id && supplierInvoiceDetail && !supplierInvoiceDetail?.isDraft) {
                                                                                    if (debounceTimerRef.current) {
                                                                                        clearTimeout(debounceTimerRef.current);
                                                                                    }

                                                                                    // Set a new timer to show the save modal after debounce period
                                                                                    debounceTimerRef.current = setTimeout(() => {
                                                                                        setSaveIndex(index);
                                                                                        if (isFinalizedInvoice) {
                                                                                            setSelectedInventoryId(partsList[index]?.inventoryId);
                                                                                        } else {
                                                                                            setSelectedInventoryId(partsList[index]);
                                                                                        }
                                                                                        setBatchNumber(part.batchNumber);
                                                                                        setOpenPartModel(true);
                                                                                    }, 1000); // 3 seconds debounce
                                                                                }
                                                                            }
                                                                        }}
                                                                    />
                                                                </TableCell>
                                                                <TableCell align="left" width={108} style={{ padding: '6px 12px' }}>
                                                                    {part.isUsedInCustomerInvoice ? (
                                                                        <div
                                                                            style={{
                                                                                background: '#F1F1F1',
                                                                                display: 'flex',
                                                                                justifyContent: 'flex-start',
                                                                                alignItems: 'center',
                                                                                borderRadius: '4px',
                                                                                height: '40px',
                                                                                padding: '0 12px',
                                                                            }}
                                                                        >
                                                                            {part?.cost
                                                                                ? NumericEngine.format(part?.cost || 0, {
                                                                                      formatCurrency: true,
                                                                                      trailingZero: true,
                                                                                  })
                                                                                : '$0.00'}
                                                                        </div>
                                                                    ) : (
                                                                        <InputWithIcon
                                                                            type="cost"
                                                                            borderRadius={'4px'}
                                                                            hideEndAdornment={part.isUsedInCustomerInvoice}
                                                                            disabled={part.isUsedInCustomerInvoice}
                                                                            skipOnChange={true}
                                                                            value={String(part?.cost || '')}
                                                                            onChange={(numericValue) => {
                                                                                if (numericValue === '' || /^\d*\.?\d{0,2}$/.test(numericValue)) {
                                                                                    let clonePartList = JSON.parse(JSON.stringify(partsList));
                                                                                    const qty = part?.qty || 0;

                                                                                    const retailPrice = numericValue === '' ? 0 : Number(numericValue);
                                                                                    const totalAmount = retailPrice
                                                                                        ? NumericEngine.multiply(retailPrice, qty)
                                                                                        : 0;

                                                                                    clonePartList[index].cost = numericValue === '' ? 0 : numericValue;
                                                                                    clonePartList[index].totalAmount = totalAmount;
                                                                                    setPartsList(clonePartList);

                                                                                    if (id && supplierInvoiceDetail && !supplierInvoiceDetail?.isDraft) {
                                                                                        if (debounceTimerRef.current) {
                                                                                            clearTimeout(debounceTimerRef.current);
                                                                                        }

                                                                                        // Set a new timer to show the save modal after debounce period
                                                                                        debounceTimerRef.current = setTimeout(() => {
                                                                                            setSaveIndex(index);
                                                                                            if (isFinalizedInvoice) {
                                                                                                setSelectedInventoryId(partsList[index]?.inventoryId);
                                                                                            } else {
                                                                                                setSelectedInventoryId(partsList[index]);
                                                                                            }
                                                                                            setBatchNumber(part.batchNumber);
                                                                                            setOpenPartModel(true);
                                                                                        }, 1000); // 3 seconds debounce
                                                                                    }
                                                                                }
                                                                            }}
                                                                        />
                                                                    )}
                                                                </TableCell>
                                                                <TableCell align="left" width={108} style={{ padding: '6px 12px' }}>
                                                                    <Typography>
                                                                        {part.totalAmount
                                                                            ? NumericEngine.format(part.totalAmount || 0, {
                                                                                  formatCurrency: true,
                                                                                  trailingZero: true,
                                                                              })
                                                                            : '$0.00'}
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell
                                                                    align="left"
                                                                    style={{
                                                                        paddingLeft: '0',
                                                                        paddingRight: '0',
                                                                    }}
                                                                >
                                                                    <Stack gap={'6px'} flexDirection={'row'}>
                                                                        {!part.isUsedInCustomerInvoice && (
                                                                            <EditIcon
                                                                                style={{
                                                                                    marginRight: '3px',
                                                                                    color: 'rgba(0, 0, 0, 0.56)',
                                                                                    cursor: part.isUpdate ? 'default' : 'pointer',
                                                                                }}
                                                                                onClick={() => {
                                                                                    if (!part.isUpdate) {
                                                                                        setSaveIndex(index);
                                                                                        if (isFinalizedInvoice) {
                                                                                            setSelectedInventoryId(partsList[index]?.inventoryId);
                                                                                        } else {
                                                                                            setSelectedInventoryId(partsList[index]);
                                                                                        }
                                                                                        setBatchNumber(part.batchNumber);
                                                                                        setOpenPartModel(true);
                                                                                    }
                                                                                }}
                                                                            />
                                                                        )}
                                                                        <Delete
                                                                            style={{
                                                                                marginRight: '3px',
                                                                                color: '#D32F2F',
                                                                                cursor: part.isUpdate ? 'default' : 'pointer',
                                                                            }}
                                                                            onClick={() => {
                                                                                if (part?.partId || part?.part?._id) {
                                                                                    setSelectedInventoryId(part?.partId || part?.part?._id);
                                                                                    setIsOpenDeleteModal(true);
                                                                                } else {
                                                                                    let clonePartList = JSON.parse(JSON.stringify(partsList));
                                                                                    clonePartList.splice(index, 1);
                                                                                    setPartsList(clonePartList);
                                                                                }
                                                                            }}
                                                                        />
                                                                    </Stack>
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                {/* <TableRow>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{
                              minWidth: "50px",
                              maxWidth: "9.6%",
                              width: "9.6%",
                            }}
                          >
                            1
                          </TableCell>
                          <TableCell align="left" style={{ minWidth: "150px" }}>
                            Labour
                          </TableCell>
                          <TableCell
                            align="left"
                            style={{
                              minWidth: "50px",
                              maxWidth: "9.6%",
                              width: "9.6%",
                            }}
                          >
                            <div className="numberArrow">
                              <KeyboardArrowUp
                                className="KeyboardArrowUp"
                                onClick={() =>
                                  setQuantityValue((prev) => (prev || 0) + 1)
                                }
                              />
                              <TextField
                                fullWidth
                                type="number"
                                value={quantityValue}
                                inputProps={{ min: "0", step: "1" }}
                                onChange={handleInputChange}
                                onBlur={handleBlur}
                              />
                              <KeyboardArrowDown
                                className="KeyboardArrowDown"
                                onClick={() =>
                                  setQuantityValue((prev) =>
                                    prev > 0 ? prev - 1 : 0
                                  )
                                }
                              />
                            </div>
                          </TableCell>
                          <TableCell
                            align="left"
                            style={{
                              minWidth: "50px",
                              maxWidth: "9.6%",
                              width: "9.6%",
                            }}
                          >
                            <div className="numberArrow">
                              <KeyboardArrowUp
                                className="KeyboardArrowUp"
                                onClick={() =>
                                  setQuantityValue((prev) => (prev || 0) + 1)
                                }
                              />
                              <TextField
                                fullWidth
                                type="number"
                                value={quantityValue}
                                inputProps={{ min: "0", step: "1" }}
                                onChange={handleInputChange}
                                onBlur={handleBlur}
                              />
                              <KeyboardArrowDown
                                className="KeyboardArrowDown"
                                onClick={() =>
                                  setQuantityValue((prev) =>
                                    prev > 0 ? prev - 1 : 0
                                  )
                                }
                              />
                            </div>
                          </TableCell>
                          <TableCell
                            align="left"
                            style={{
                              minWidth: "50px",
                              maxWidth: "9.6%",
                              width: "9.6%",
                            }}
                          >
                            $000.00
                          </TableCell>

                          <TableCell
                            align="left"
                            style={{ width: "24px", padding: "0" }}
                          >
                            <EditIcon
                              style={{
                                marginRight: "3px",
                                color: "rgba(0, 0, 0, 0.56)",
                              }}
                            />
                          </TableCell>
                        </TableRow> */}
                                            </TableBody>
                                        </Table>
                                    </div>
                                </Grid>
                            </Grid>

                            <Grid item container padding={'12px 0px'}>
                                <Grid item>
                                    <Button
                                        color="primary"
                                        variant="outlined"
                                        startIcon={<Add />}
                                        onClick={() => {
                                            if (getValues().supplierId && getValues().invoiceNumber) {
                                                setOpenPartModel(true);
                                            } else {
                                                toast.error(
                                                    `Please  ${!getValues().supplierId ? 'select a supplier' : 'add invoice number'} before adding a part.`
                                                );
                                            }
                                        }}
                                        className="btn-text-size-manage"
                                        sx={{ mb: 2 }}
                                    >
                                        ADD Part
                                    </Button>
                                </Grid>
                            </Grid>
                            <Divider
                                style={{
                                    width: '100%',
                                    borderBottomStyle: 'dotted',
                                    borderBottomWidth: '4px',
                                }}
                            />

                            <DiscountComponent
                                isHide={true}
                                // discountId={discountId}
                                // setDiscountId={setDiscountId}
                                // setSelectedDiscount={setSelectedDiscount}
                                totals={totals}
                                setTotals={setTotals}
                                // discountList={discountList.length > 0 ? discountList : []}
                            />
                        </Grid>
                    </Grid>
                    <Grid
                        justifyContent={{ md: 'space-between', xs: '' }}
                        bgcolor={'white'}
                        container
                        padding={'24px'}
                        margin={' 17px 0px 32px 0'}
                        boxShadow={2}
                        borderRadius={2}
                        alignItems={'center'}
                        rowGap={2}
                    >
                        <Grid item container lg={7} alignItems={'end'} rowGap={2}>
                            <Grid xs={6} sm={5}>
                                <Typography fontWeight={500} mb={0.5}>
                                    {' '}
                                    Payment Status
                                </Typography>
                                <Controller
                                    name="paymentStatus"
                                    control={control}
                                    render={({ field }) => (
                                        <Autocomplete
                                            fullWidth
                                            disableClearable
                                            options={PAYMENT_STATUS}
                                            getOptionLabel={(option) => option.value}
                                            value={PAYMENT_STATUS.find((option) => option.key === field.value?.key) || null}
                                            onChange={(_, newValue) => {
                                                field.onChange(newValue);
                                                setRender(!render);
                                            }}
                                            ListboxProps={{
                                                style: { maxHeight: '280px' },
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} error={!!errors.paymentStatus} helperText={errors.paymentStatus?.message || ''} />
                                            )}
                                            renderOption={(props, option) => (
                                                <li
                                                    key={props.key}
                                                    {...props}
                                                    style={{
                                                        height: '44px',
                                                        paddingRight: '0px',
                                                    }}
                                                >
                                                    {option.value}
                                                </li>
                                            )}
                                        />
                                    )}
                                />
                            </Grid>

                            {getValues().paymentStatus?.key === 'partial_payment' && (
                                <Grid xs={6} sm={4}>
                                    <Controller
                                        name="amountPaid"
                                        control={control}
                                        // rules={{
                                        //   required: "Amount is required",
                                        // }}
                                        render={({ field }) => (
                                            <TextField
                                                style={{ width: '160px' }}
                                                variant="outlined"
                                                size="medium"
                                                value={field.value}
                                                label="Amount Paid($)"
                                                onChange={(e) => {
                                                    const inputValue = e.target.value;
                                                    const numericValue = inputValue;
                                                    if (numericValue > totals.estimatedTotal) {
                                                        toast.error('Payment amount cannot be higher that pending amount.');
                                                        setError('amountPaid', {
                                                            message: 'amountPaid',
                                                        });
                                                        field.onChange(Number(numericValue));
                                                    } else {
                                                        clearErrors('amountPaid');
                                                        field.onChange(Number(numericValue));
                                                    }
                                                }}
                                                onKeyDown={handlePreventKeyDownDecimal}
                                                error={!!errors.amountPaid}
                                            />
                                        )}
                                    />
                                </Grid>
                            )}
                        </Grid>
                        <Grid item display="flex" justifyContent={{ xs: 'end', lg: 'end' }} flexWrap={{ xs: 'wrap', sm: 'nowrap' }} gap={2} lg={5}>
                            <Button
                                color="error"
                                variant="contained"
                                className="btn-text-size-manage"
                                onClick={() => navigate(-1)}
                                sx={{ whiteSpace: 'nowrap', height: '42px' }} // Prevent label from wrapping
                            >
                                CANCEL
                            </Button>

                            {id && id !== '' && supplierInvoiceDetail?.isDraft === false ? (
                                <></>
                            ) : (
                                <Button
                                    variant="contained"
                                    type="submit"
                                    className="btn-text-size-manage"
                                    startIcon={<SaveAsDraftSvg />}
                                    onClick={() => setIsSaveDraft(true)}
                                    style={{
                                        background: 'rgba(0, 0, 0, 0.10)',
                                        boxShadow: ' 0px 1px 4px 0px rgba(0, 0, 0, 0.25)',
                                        color: '#000',
                                        width: '200px',
                                    }}
                                >
                                    SAVE AS DRAFT
                                </Button>
                            )}

                            <Button
                                variant="contained"
                                className="btn-text-size-manage"
                                type="submit"
                                // disabled={isFinalizedInvoice}
                                onClick={() => setIsSaveDraft(false)}
                                sx={{ whiteSpace: 'nowrap', height: '42px' }} // Prevent label from wrapping
                            >
                                SAVE
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Box>

            <Dialog fullScreen={false} open={showLoader}>
                <DialogContent>
                    <CircularProgress />
                </DialogContent>
            </Dialog>

            <PartUsedInvoiceModal
                open={partInvoiceModal}
                batchNumber={batchNumber}
                inventoryId={selectedInventoryId}
                supplierInvoiceId={supplierInvoiceDetail?._id}
                supplierId={supplierInvoiceDetail?.supplier?._id}
                onClose={() => {
                    setBatchNumber(null);
                    setSelectedInventoryId(null);
                    setPartInvoiceModal(false);
                }}
            />

            <CommonDialog
                loader={isDelete}
                open={isOpenDeleteModal}
                onClose={() => {
                    if (!isDelete) {
                        setSelectedInventoryId(null);
                        setIsOpenDeleteModal(false);
                    }
                }}
                onSave={async () => {
                    try {
                        setIsDelete(true);

                        let resp = await deletePartFromSupplierInvoiceApi({ supplierInvoiceId: id, partId: selectedInventoryId });

                        if (resp) {
                            fetchSupplierInvoiceDetail();
                            setIsOpenDeleteModal(false);
                            setSelectedInventoryId(null);
                        }
                    } catch (error) {
                    } finally {
                        setIsDelete(false);
                    }
                }}
                dialogTitle={'Delete Inventory?'}
                dialogSubtitle={'Are you sure you want to delete this part from the supplier invoice? This action cannot be undone.'}
            />

            {isFinalizedInvoice ? (
                <AddInventoryModal
                    type={INVENTORY_TYPES.SUPPLIER_INVOICE}
                    supplierId={getValues().supplierId}
                    supplierInvoiceNumber={getValues().invoiceNumber}
                    supplierInvoiceQty={partsList[saveIndex]?.qty}
                    supplierInvoiceCost={partsList[saveIndex]?.cost}
                    inventoryId={selectedInventoryId}
                    batchNumber={batchNumber}
                    openModal={openPartModel}
                    closeModal={() => {
                        setSelectedInventoryId(null);
                        setBatchNumber(null);
                        setSaveIndex(0);
                        setOpenPartModel(false);
                        fetchSupplierInvoiceDetail();
                    }}
                    onSubmitModal={() => {
                        setSelectedInventoryId(null);
                        setBatchNumber(null);
                        setSaveIndex(0);
                        setOpenPartModel(false);
                    }}
                    ShowAllTabs={false}
                    ShowTabIndex={0}
                    partIndex={saveIndex}
                    showLoader={inventoryLoader}
                    setShowLoader={isSetInventoryLoader}
                    selectedInventory={selectedInventory}
                    setSelectedInventory={setSelectedInventory}
                    // setPartsList={setPartsList}
                    // partsList={partsList}
                    fetchApi={(data) => {
                        setShowLoader(true);
                        onSubmitInvoice(getValues(), true);
                    }}
                />
            ) : (
                <AddInventoryForSupplierInvoice
                    supplierId={getValues().supplierId}
                    supplierInvoiceNumber={getValues().invoiceNumber}
                    batchNumber={batchNumber}
                    inventoryId={selectedInventoryId}
                    openModal={openPartModel}
                    closeModal={() => {
                        setSelectedInventoryId(null);
                        setSaveIndex(0);
                        setOpenPartModel(false);
                    }}
                    onSubmitModal={() => {
                        setSelectedInventoryId(null);
                        setSaveIndex(0);
                        setOpenPartModel(false);
                    }}
                    partIndex={saveIndex}
                    showLoader={inventoryLoader}
                    setShowLoader={isSetInventoryLoader}
                    selectedInventory={selectedInventory}
                    setSelectedInventory={setSelectedInventory}
                    setPartsList={setPartsList}
                    partsList={partsList}
                    fetchApi={(data) => {}}
                />
            )}
        </>
    );
};

export default SupplierNewInvoice;
